import {CSSObject} from '@emotion/react'

import {gradientBorder} from 'src/styles/borders'
import {typography} from 'src/styles'
import {gradients} from 'src/styles/gradients'

import {Theme} from './theme'

const buttonHeight = 44
const borderWidth = 3

export const buttonVariants = {
  primary: {
    ...gradientBorder(gradients.primaryButton),
    color: (theme: Theme) => theme.colors.primary,
  },
  secondary: {
    borderColor: (theme: Theme) => theme.colors.grey4,
    color: (theme: Theme) => theme.colors.grey6,
  },
  disabled: {
    borderColor: (theme: Theme) => theme.colors.grey1,
    color: (theme: Theme) => theme.colors.grey2,
  },
} as const

export type ButtonVariant = keyof typeof buttonVariants

export const buttonCss = {
  reset: {
    border: 0,
    boxSizing: 'border-box',
    margin: 0,
    padding: 0,
  },
  misc: ({theme}: {theme: Theme}): CSSObject => ({
    backgroundColor: theme.colors.white,
    color: 'inherit',
    cursor: 'pointer',
    display: 'inline-block',
    height: buttonHeight,
    minWidth: 150,
    position: 'relative',
  }),
  typography: {
    ...typography.lede,
    lineHeight: `${buttonHeight - borderWidth * 2}px`,
    textAlign: 'center',
    textDecoration: 'none',
  },
  border: {
    border: `solid ${borderWidth}px transparent`,
    borderRadius: 100,
  },
  space: ({theme}: {theme: Theme}) => ({
    padding: `0 ${theme.space[2]}`,
  }),
} as const

export const buttonBaseCss = [
  buttonCss.reset,
  buttonCss.misc,
  buttonCss.typography,
  buttonCss.border,
  buttonCss.space,
]
